<template>
    <v-card>
        <loader :loader="sending" />

        <v-card-title class="text-h6 text-center">
            Estudios realizados
        </v-card-title>
        <v-card-text>

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line class="mb-8"
                outlinedx></v-text-field>

            <v-data-table :headers="headers" :items="list" :items-per-page="itemsPerPage" :search="search" height="auto"
                class="mb-8" no-data-text="Sin resultados disponibles" 
        fixed-header
        :footer-props="footerProps"
        dense
      >
        <template v-slot:[`item.interpretationDate`]="{ item }">
          {{ $utilFront.formatDateTime(item.interpretationDate) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon @click="exportToPDF(item)" class="mr-6">
                <v-icon color="red" v-bind="attrs" v-on="on">
                  mdi-file-pdf-box
                </v-icon>
              </v-btn>
            </template>
            <span>Informe médico</span>
          </v-tooltip>

          <v-tooltip top v-if="item.modality !== 'PAP - PAPANICOLAOU'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon @click="downloadZIP(item)">
                <v-icon color="secondary" v-bind="attrs" v-on="on">
                  mdi-folder-download
                </v-icon>
              </v-btn>
            </template>
            <span>Descargar DICOM</span>
          </v-tooltip>
          <v-tooltip top v-if="item.modality === 'PAP - PAPANICOLAOU'" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon @click="exportViewPDF(item)" v-bind="attrs" v-on="on">
                <v-icon color="red">mdi-file-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>Resultados laboratorio</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn color="error" text @click="setShowDialogStudies()">
        <v-icon left> mdi-chevron-left</v-icon>Volver
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest
} from "@/core/request";
import Loader from "@/app/components/base/loader/Loader.vue";

export default {
  name: "DialogStudy",
  props: {
    setShowDialogStudies: Function,
    idPatient: String,
  },
  components: {
    Loader,
  },
  data() {
    return {
      sending: false,
      itemsPerPage: 5,
      list: [],
      search: "",
      headers: [
        { text: "Id Estudio", value: "idStudy", sortable: false, align: "center" },
        { text: "Fecha de interpretación", value: "interpretationDate", align: "center", sortable: false },
        { text: "Modalidad", value: "modality", align: "center", sortable: false },
        { text: "Estudio", value: "studyModality", align: "center", sortable: false },
        { text: "Intérprete", value: "interpreter", align: "center", sortable: false },
        { text: "Acciones", value: "actions", sortable: false, align: "center", width: "15%" },
      ],
    };
  },
  computed: {
    footerProps() {
      return {
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
        'items-per-page-options': [5, 10],
      };
    },
  },
  mounted() {
    this.findAllStudiesByPatient();
  },
  methods: {
    findAllStudiesByPatient() {
      this.list = [];
      StudyRequest.findAllStudiesByPatient(this.idPatient).then((response) => {
        const { data } = response.data;
        if (data) {
          this.list = data;
        }
      });
    },

    exportToPDF(item) {
      if (item.modality === "PAP - PAPANICOLAOU") {
        this.sending = true;
        const data = {
          idStudy: item.idStudy,
          type: 1,
          idBranchOffice: this.$utilFront.getIdBranchOffice()
        };

        StudyRequest.papanicolaouDowloadReport(data)
        .then(res => {
          if (res.status === 200 && res.data.type === "application/json") {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .catch(err => {
          console.error(err);
          this.$utilFront.notification("Error al abrir  el PDF", "ERROR");
        })
        .finally(() => {
          this.sending = false;
        });

      } else {
        this.sending = true;
        let data = {
          idInterpretation: item.idInterpretation,
          fileName: "Interpretacion",
        };

        ReportPDFRequest.downloadInterpretation1(data)
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    async exportViewPDF(item) {
    this.sending = true;

    const payload = { idStudy: item.idStudy };

    try {
      const res = await StudyRequest.papanicolaouViewReport(payload);
      const files = res.data.studyFiles;

      if (!files || files.length === 0 || !files[0].bytes) {
        this.$utilFront.notification(
          "No se encontró PDF para este estudio",
          "ERROR"
        );
        return;
      }

      const base64 = files[0].bytes;
      const binary = atob(base64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: "application/pdf" });

      window.open(URL.createObjectURL(blob));

    } catch (err) {
      console.error(err);
      this.$utilFront.notification(
        "Error al descargar el PDF de Papanicolaou",
        "ERROR"
      );
    } finally {
      this.sending = false;
    }
  },

    downloadZIP(item) {
      this.sending = true;
      let data = { idStudy: item.idStudy };
      DownloadZipRequest.downloadImagesDCM(data)
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.idStudy + ".zip");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error al descargar ZIP:", error);
          this.$utilFront.notifications("Error al descargar archivo DICOM", "ERROR");
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
